// Interface settings kept on the account (GET / PUT /preferences, server/sql/009), so they follow the person to any
// computer or phone: the columns chosen with „Coloane” on each table. Loaded once per login, written a moment after
// the last change (several clicks in a row = one request).
import axios from "@/store/interceptor";
import apiUrl from "@/config/api.config";

const SAVE_DELAY = 600;

// { userId, promise of { key: value } }
let loaded = null;
const timers = {};

export function loadPreferences(userId) {
  if (!loaded || loaded.userId !== userId) {
    const promise = axios
      .get(`${apiUrl}/preferences`)
      .then((response) => response.data || {})
      // without them every page simply shows its defaults
      .catch(() => ({}));
    loaded = { userId, promise };
  }
  return loaded.promise;
}

export async function getPreference(userId, key) {
  if (!userId) return undefined;
  return (await loadPreferences(userId))[key];
}

/** `value` null forgets the setting (back to the defaults) */
export function savePreference(userId, key, value) {
  if (!userId) return;
  if (loaded && loaded.userId === userId) {
    loaded.promise = loaded.promise.then((all) => {
      const next = { ...all };
      if (value === null) delete next[key];
      else next[key] = value;
      return next;
    });
  }
  clearTimeout(timers[key]);
  timers[key] = setTimeout(() => {
    delete timers[key];
    const url = `${apiUrl}/preferences/${encodeURIComponent(key)}`;
    (value === null ? axios.delete(url) : axios.put(url, { value })).catch((error) => {
      console.error("Setarea nu a fost salvată:", error);
    });
  }, SAVE_DELAY);
}

// at logout: the next person starts from their own settings
export function clearPreferences() {
  Object.keys(timers).forEach((key) => {
    clearTimeout(timers[key]);
    delete timers[key];
  });
  loaded = null;
}
